// inner-hero.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor =
  document.body.classList.contains("block-editor-page") ||
  document.body.classList.contains("wp-admin");

if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function imagesReady(scope, cb) {
  const imgs = Array.from(scope.querySelectorAll("img"));
  if (!imgs.length) return cb();
  let left = imgs.length;
  const done = () => (--left === 0 ? cb() : null);
  imgs.forEach((img) => {
    if (img.complete) return done();
    img.addEventListener("load", done, { once: true });
    img.addEventListener("error", done, { once: true });
  });
}

/* ---------------- main ---------------- */
function initInnerHero(section) {
  if (!section || section.__heroInit) return;
  section.__heroInit = true;

  const eyebrow = section.querySelector(".inner-hero__eyebrow");
  const headline = section.querySelector(".inner-hero__headline");
  const intro = section.querySelector(".inner-hero__intro");
  const image = section.querySelector(".inner-hero__img--main");

  gsap.set([eyebrow, headline, intro], { opacity: 0, y: 24 });
  if (image) gsap.set(image, { opacity: 0, y: 24 });

  const play = () => {
    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 });
    if (headline)
      tl.to(headline, { opacity: 1, y: 0, duration: 0.65 }, "-=0.25");
    if (intro) tl.to(intro, { opacity: 1, y: 0, duration: 0.55 }, "-=0.35");

    if (image) {
      tl.to(image, { opacity: 1, y: 0, duration: 0.65 }, "-=0.45");

      // optional parallax if data attribute exists
      const mult = parseFloat(image.getAttribute("data-parallax")) || 0.04;
      if (!isEditor) {
        gsap.to(image, {
          yPercent: -mult * 100,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        });
      }
    }
  };

  if (isEditor) return play();

  ScrollTrigger.create({
    trigger: section,
    start: "top 75%",
    once: true,
    onEnter: play,
  });
}

function mount() {
  document.querySelectorAll(".inner-hero").forEach(initInnerHero);

  if (isEditor) {
    const root = document.querySelector(".editor-styles-wrapper") || document;
    new MutationObserver(() =>
      root.querySelectorAll(".inner-hero").forEach(initInnerHero)
    ).observe(root, { childList: true, subtree: true });
  }
}

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
